import React from "react";

import { UIRender } from "../../utils/CommonGroupingItem";

/** Status dropdown options for report create/edit forms. */
export const REPORT_STATUS_OPTIONS = [
  { value: 1, label: "Active" },
  { value: 0, label: "Draft" },
];

/**
 * Renders a styled report category badge.
 * @param {string|number} categoryValue - Category id or label from the API.
 * @param {boolean} [origin=true] - Whether to render with origin styling.
 * @returns {Object} UI render object with text and html.
 */
export const RenderReportCategory = (categoryValue, origin = true) => {
  const normalizedValue = categoryValue?.toString().toLowerCase() || "";

  switch (normalizedValue) {
    case "1":
    case "registrations":
      return UIRender({
        color: "cat-green",
        text: "Registrations",
        type: "brandList",
        origin,
      });

    case "2":
    case "students":
      return UIRender({
        color: "cat-orange",
        text: "Students",
        type: "brandList",
        origin,
      });

    case "3":
    case "courses":
      return UIRender({
        color: "cat-purple",
        text: "Courses",
        type: "brandList",
        origin,
      });

    case "4":
    case "assessments":
      return UIRender({
        color: "cat-blue",
        text: "Assessments",
        type: "brandList",
        origin,
      });

    case "5":
    case "finance":
      return UIRender({
        color: "cat-red",
        text: "Finance",
        type: "brandList",
        origin,
      });

    case "6":
    case "other":
      return UIRender({
        color: "cat-grey",
        text: "Other",
        type: "brandList",
        origin,
      });

    default:
      return UIRender({
        color: "cat-blue",
        text: categoryValue || "-",
        type: "brandList",
        origin,
      });
  }
};

/**
 * Renders a styled report status badge.
 * @param {string|number} statusValue - Report status value from the API.
 * @returns {{ text: string, html: JSX.Element }} Status label and rendered badge.
 */
export const RenderReportStatus = (statusValue) => {
  const normalizedValue = statusValue?.toString() || "";

  switch (normalizedValue) {
    case "1":
      return {
        text: "Active",
        html: <p className="as-green-bg as-widget m-0">ACTIVE</p>,
      };

    case "0":
      return {
        text: "Draft",
        html: <p className="as-red-bg as-widget m-0">DRAFT</p>,
      };

    default:
      return {
        text: statusValue || "-",
        html: <p className="as-black-bg as-widget m-0">{statusValue || "-"}</p>,
      };
  }
};
